class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      // this.closest("cart-items").updateQuantity(this.dataset.index, 0);
      if (this.closest("cart-drawer-items")) {
        this.closest("cart-drawer-items").updateQuantity(this.dataset.index, 0);
      } else if (this.closest("cart-items")) {
        this.closest("cart-items").updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        const parsedState = JSON.parse(state);
        await this.fullCartUpdate();
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartFooter = document.getElementById("main-cart-footer");
        const totalFooter = document.getElementsByClassName(
          "totals__subtotal-value"
        );
        const cartCounter = document.getElementsByClassName(
          "js-ajax-cart-counter"
        );
        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (totalFooter.length)
          totalFooter[0].innerHTML = this.formatMoney(
            parsedState.total_price,
            totalFooter[0].getAttribute("data-money").replace(/['"]+/g, "")
          );
        if (cartCounter.length) {
          cartCounter[0].innerHTML = parsedState.item_count;
          if (Number(parsedState.item_count) === 0) {
            cartCounter[0].classList.add("hidden");
            cartCounter[0].classList.remove("visible");
          } else {
            cartCounter[0].classList.add("visible");
            cartCounter[0].classList.remove("hidden");
          }
        }
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        // document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus = document.getElementById("cart-live-region-text");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  async fullCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      return await fetch(`${routes.cart_update_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          console.log(html);
          const selectors = [
            ".cart-drawer",
            ".js-ajax-cart-counter.visible"
            // ".drawer__inner-empty",
            // "cart-drawer-items",
            // ".cart-drawer__footer",
          ];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            console.log(sourceElement);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          console.log(
            document
              .querySelector("cart-drawer-items")
              .classList.contains("is-empty")
          );
          if (
            !document
              .querySelector("cart-drawer-items")
              .classList.contains("is-empty")
          ) {
            if (
              document
                .querySelector("cart-drawer")
                .classList.contains("is-empty")
            ) {
              document
                .querySelector("cart-drawer")
                .classList.remove("is-empty");
              const emptyDrawer = document.querySelector(
                ".drawer__inner-empty"
              );
              if (emptyDrawer) {
                emptyDrawer.style.display = "none";
              }
            }
          } else {
            console.log(
              !document
                .querySelector("cart-drawer")
                .classList.contains("is-empty")
            );
            if (
              !document
                .querySelector("cart-drawer")
                .classList.contains("is-empty")
            ) {
              document.querySelector("cart-drawer").classList.add("is-empty");
              if (document.querySelector(".drawer__footer")) {
                document.querySelector(".drawer__footer").style.display =
                  "none";
              }
              if (document.querySelector(".drawer__inner-empty")) {
                document.querySelector(".drawer__inner-empty").style.display =
                  "flex";
              }
              document
                .querySelector(".js-ajax-cart-counter")
                .classList.add("hidden");
              document.querySelector(".js-ajax-cart-counter").innerHTML = "0";
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      const footer = document.querySelector(".cart__footer");
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
      fetch(`${routes.cart_update_url}?section_id=main-cart-footer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector(".cart__footer");
          footer.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  // enableLoading(line) {
  //   document
  //     .getElementById("main-cart-items")
  //     .classList.add("cart__items--disabled");
  //   this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
  //     (overlay) => overlay.classList.remove("hidden")
  //   );
  //   document.activeElement.blur();
  //   this.lineItemStatusElement.setAttribute("aria-hidden", false);
  // }

  // disableLoading() {
  //   document
  //     .getElementById("main-cart-items")
  //     .classList.remove("cart__items--disabled");
  // }
  enableLoading(line) {
    this.classList.add("cart__items--disabled");
    if (this.contains(document.querySelector("#CartDrawer-Form"))) {
      this.querySelectorAll(
        `#CartDrawer-Item-${line} .loading-overlay`
      ).forEach((overlay) => overlay.classList.remove("hidden"));
    } else if (this.contains(document.querySelector("#main-cart-items"))) {
      this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
        (overlay) => overlay.classList.remove("hidden")
      );
    }
    document.activeElement.blur();
    // this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    this.classList.remove("cart__items--disabled");
  }

  defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  formatWithDelimiters(number, precision, thousands, decimal) {
    precision = this.defaultOption(precision, 2);
    thousands = this.defaultOption(thousands, ",");
    decimal = this.defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }
  formatMoney(cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = this.formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = this.formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = this.formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = this.formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }
}

customElements.define("cart-items", CartItems);
